// extracted by mini-css-extract-plugin
module.exports = {"custom-logo-wrapper":"sideBar_custom-logo-wrapper__3yQWL"};